"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
exports.CheckIcon = function () {
    return (react_1.default.createElement("svg", { id: "checkIcon", xmlns: "http://www.w3.org/2000/svg", xmlnsXlink: "http://www.w3.org/1999/xlink", width: "16", height: "16", viewBox: "0 0 16 16" },
        react_1.default.createElement("defs", null,
            react_1.default.createElement("polygon", { id: "check-a", points: "11.459 5 6.94 9.563 4.469 7.112 3 8.574 6.94 12.549 12.944 6.601" })),
        react_1.default.createElement("g", { fill: "none", fillRule: "evenodd" },
            react_1.default.createElement("mask", { id: "check-b", fill: "#fff" },
                react_1.default.createElement("use", { xlinkHref: "#check-a" })),
            react_1.default.createElement("use", { fill: "#0098DB", xlinkHref: "#check-a" }),
            react_1.default.createElement("g", { fill: "#0098DB", mask: "url(#check-b)" },
                react_1.default.createElement("rect", { width: "16", height: "16" })))));
};
